export enum FormFlowType {
    NORMAL = 'NORMAL',
    INFORMED = 'INFORMED',
}